// extracted by mini-css-extract-plugin
export default {"user_info_data__container":"user-info-data_user_info_data__container__SauTO","title":"user-info-data_title__skWDk","role":"user-info-data_role__9tDlj"};